import moment from 'moment-timezone'
import { TIME_ZONE } from 'const/common'

/**
 * 判断期权是否过期
 * @param {number} expiry - 过期时间
 *
 * @return {boolean}
 */
export default function isOptionExpired(expiry) {
  return moment
    .tz(expiry, TIME_ZONE.US)
    .isBefore(moment().tz(TIME_ZONE.US), 'day')
}
